import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { AppMain, Navbar, Sidebar } from './components';
import ResizeMixin from './mixin/resize';
import NavMain from './components/navbar/main.vue';
import XplorerFooter from './components/footer/footer.vue';
import { isHomePath } from '@/router/components/layout/utils';
let default_1 = class extends mixins(ResizeMixin) {
    get classObj() {
        return {
            hideSidebar: !this.sidebar.opened,
            openSidebar: this.sidebar.opened,
            withoutAnimation: this.sidebar.withoutAnimation,
        };
    }
    get showFullScreen() {
        return !!this.$route?.meta?.fullScreen;
    }
    isHomePath() {
        return isHomePath(this.$route.path);
    }
};
default_1 = __decorate([
    Component({
        name: 'Layout',
        components: {
            AppMain,
            Navbar,
            Sidebar,
            NavMain,
            'xplorer-footer': XplorerFooter,
        },
    })
], default_1);
export default default_1;
